import Vue from 'vue';
import Router from 'vue-router';
import Patients from './views/Patients.vue';
import Dashboard from './views/Dashboard.vue';
import Providers from './views/Providers.vue';
import Login from './views/Login.vue';
import Utilization from './views/Utilization.vue';
import Membership from './views/Membership.vue';
import Coding from './views/Coding.vue';
import Quality from './views/Quality.vue';
import Notifications from './views/Notifications.vue';
import Pwchange from './views/Pwchange.vue';
import Admin from './views/Admin.vue';
import Tasks from './views/Tasks.vue';
import Contract from './views/Contract.vue';
import AIReports from './views/AIReports.vue';
import errorPage from './components/errorPages/404.vue';
import Authorizations from './views/Authorizations.vue';
import Careplans from './views/Careplans.vue';
import Finance from './views/Finance.vue';
import KPIs from './views/KPIs.vue';
import Claims from './views/ClaimsSearch.vue';
import ClaimsManagement from './views/Claims.vue';
import Member from './views/Member.vue';
import Maps from './components/memberPortal/map.vue';
import ProviderSearchMap from './views/ProviderSearchMap.vue';
import ProviderDetailsPage from './views/ProviderDetailsPage.vue';
import MemberEnrollment from './views/MemberEnrollment.vue';
import SharedPatient from './views/SharedPatient.vue';
import BillingInformation from './views/BillingInformation.vue';
import BillingMember from './views/BillingMember.vue';
import ExplanationOfPayment from './views/ExplanationOfPayment.vue';
import RAPS from './views/RAPS.vue';
import RAPSRecords from './views/RAPSRecords.vue';
import RAPSAnalyzeExternal from './views/RAPSAnalyzeExternal.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
    },
    {
      path: '/pwchange/:token',
      name: 'pwchange',
      component: Pwchange,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/patients',
      name: 'patients',
      component: Patients,
    },
    {
      path: '/patient-lookup',
      name: 'patient-lookup',
      component: () => import('./views/PatientLookup.vue'),
    },
    {
      path: '/providers',
      name: 'providers',
      component: Providers,
    },
    {
      path: '/providers/:npi',
      name: 'provider-detail',
      component: Providers,
      props: true,
    },
    {
      path: '/provider-details',
      name: 'provider-details',
      component: ProviderDetailsPage,
    },
    // MEMBER PORTAL ROUTE
    {
      path: '/member',
      name: 'member',
      component: Member,
    },
    {
      path: '/sharedpatient/:id',
      name: 'SharedPatient',
      component: SharedPatient,
    },
    {
      path: '/map',
      name: 'map',
      component: Maps,
    },
    {
      path: '/providers-map',
      name: 'providers-map',
      component: ProviderSearchMap,
    },
    {
      path: '/member-enrollment',
      name: 'member-enrollment',
      component: MemberEnrollment,
    },
    {
      path: '/member-contact',
      name: 'MemberContactInfo',
      component: () => import('./views/MemberContactInfo.vue'),
    },
    {
      path: '/member-payments',
      name: 'MemberPayments',
      component: () => import('./views/MemberPayments.vue'),
    },
    {
      path: '/member-cards',
      name: 'MemberCards',
      component: () => import('./views/MemberCards.vue'),
    },
    {
      path: '/easy-drug-card',
      name: 'EasyDrugCard',
      component: () => import('./views/EasyDrugCard.vue'),
    },
    {
      path: '/resources',
      name: 'Resources',
      component: () => import('./views/Resources.vue'),
    },
    {
      path: '/my-documents',
      name: 'MyDocuments',
      component: () => import('./views/MyDocuments.vue'),
    },
    {
      path: '/finlay-lab',
      name: 'FinlayLab',
      component: () => import('./views/FinlayLab.vue'),
    },
    {
      path: '/resources-admin',
      name: 'ResourcesAdmin',
      component: () => import('./views/ResourcesAdmin.vue'),
    },
    {
      path: '/finance',
      name: 'finance',
      component: Finance,
    },
    {
      path: '/kpis',
      name: 'kpis',
      component: KPIs,
    },
    {
      path: '/tasks',
      name: 'tasks',
      component: Tasks,
    },
    ...(process.env.VUE_APP_CUSTOMER !== 'Elderone' ? [{
      path: '/careplans',
      name: 'careplans',
      component: () => import('./views/Careplans.vue'),
    }] : []),
    {
      path: '/claims',
      name: 'claims',
      component: Claims,
    },
    {
      path: '/claims-management',
      name: 'claims-management',
      component: ClaimsManagement,
    },
    {
      path: '/contract',
      name: 'contract',
      component: Contract,
    },
    {
      path: '/utilization',
      name: 'utilization',
      component: Utilization,
    },
    {
      path: '/membership',
      name: 'membership',
      component: Membership,
    },
    {
      path: '/AIReports',
      name: 'AIReports',
      component: AIReports,
    },
    {
      path: '/authorizations',
      name: 'authorizations',
      component: Authorizations,
    },
    {
      path: '/coding',
      name: 'coding',
      component: Coding,
    },
    {
      path: '/quality',
      name: 'quality',
      component: Quality,
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: Notifications,
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
    },
    {
      path: '/admin/midpay-test',
      name: 'AdminMidpayTestCharge',
      component: () => import('./views/AdminMidpayTestCharge.vue'),
    },
    {
      path: '/404',
      name: 'error',
      component: errorPage,
    },
    {
      path: '/billing-information',
      name: 'BillingInformation',
      component: BillingInformation,
    },
    {
      path: '/billing-member',
      name: 'BillingMember',
      component: BillingMember,
    },
    {
      path: '/explanation-of-payment',
      name: 'ExplanationOfPayment',
      component: ExplanationOfPayment,
    },
    {
      path: '/raps',
      name: 'RAPS',
      component: RAPS,
    },
    {
      path: '/raps/:id/records',
      name: 'RAPSRecords',
      component: RAPSRecords,
    },
    {
      path: '/raps/analyze-external',
      name: 'RAPSAnalyzeExternal',
      component: RAPSAnalyzeExternal,
    },
    {
      path: '/provider-documents',
      name: 'ProviderDocuments',
      component: () => import('./views/ProviderDocuments.vue'),
    },
    // {
    //   path: '*',
    //   redirect: '/404',
    // },
  ],
});

// Navigation guard para redirecionar FamilyHealthChoice sempre para /member-enrollment
// MAS priorizar troca de senha obrigatória
router.beforeEach(async (to, from, next) => {
  // Se estiver acessando a raiz e não estiver autenticado, redirecionar direto para login
  if (to.path === '/') {
    const userData = localStorage.getItem('user');
    if (!userData) {
      // Usuário não autenticado, redirecionar direto para login sem mostrar mensagem
      next('/login');
      return;
    }
  }

  // Se não estiver indo para login ou pwchange, verificar autenticação
  if (to.path !== '/login' && !to.path.startsWith('/pwchange')) {
    const userData = localStorage.getItem('user');

    // Se não tem userData e não está indo para login, redirecionar para login
    if (!userData) {
      next('/login');
      return;
    }

    // Se tem userData, verificar se é válido
    let user = null;
    try {
      user = JSON.parse(userData);
    } catch (e) {
      // Erro ao fazer parse, considerar não autenticado
      console.error('Error parsing user data:', e);
      next('/login');
      return;
    }

    // Se user é null ou não tem propriedades essenciais, redirecionar para login
    if (!user || !user.role) {
      next('/login');
      return;
    }

    // Roles fmo / agent / fmo_org belong to the other platform and have no
    // access here. Login is already blocked server-side; this covers a stale
    // session in localStorage. Clear it and send to /login.
    const platformBlockedRoles = ['fmo', 'agent', 'fmo_org'];
    if (to.path !== '/login' && platformBlockedRoles.includes(String(user.role).toLowerCase())) {
      localStorage.removeItem('user');
      next('/login');
      return;
    }

    // PRIORIDADE 1: Verificar se precisa trocar senha
    const resetToken = localStorage.getItem('resetPasswordToken');
    const resetTokenExpiry = localStorage.getItem('resetPasswordTokenExpiry');
    const needsPasswordChange = (user.firstLogin != null ? user.firstLogin : user.first_login) === true;
    if (resetToken) {
      if (resetTokenExpiry && Date.now() > parseInt(resetTokenExpiry, 10)) {
        localStorage.removeItem('resetPasswordToken');
        localStorage.removeItem('resetPasswordTokenExpiry');
        next('/login');
        return;
      }
      // Só redireciona se firstLogin ainda for true — token stale não deve bloquear usuários normais
      if (!needsPasswordChange) {
        localStorage.removeItem('resetPasswordToken');
        localStorage.removeItem('resetPasswordTokenExpiry');
      } else {
        console.log('🔐 Router guard: Found reset token, redirecting to /pwchange');
        next(`/pwchange/${resetToken}`);
        return;
      }
    }

    // Se não tem token, verificar no user se firstLogin === true (compat: first_login)
    if ((user.firstLogin != null ? user.firstLogin : user.first_login) === true) {
      // Precisa trocar senha mas não tem token no localStorage
      // Isso pode acontecer se o usuário foi salvo mas o token não foi
      // Redirecionar para login para que o fluxo normal aconteça
      console.log('⚠️ Router guard: Password change required but no token found, redirecting to login');
      next('/login');
      return;
    }

    // PRIORIDADE 2: Se não precisa trocar senha, verificar se é FamilyHealthChoice
    // Só aplicar redirecionamento se o usuário estiver realmente autenticado
    if (user && user.insurance && Array.isArray(user.insurance)) {
      const isFamilyHealthChoice = user.insurance.some(ins =>
        ins === 'FamilyHealthChoice' || ins === 'FloridaHealthChoice'
      );
      // Se for FamilyHealthChoice e role Member, redirecionar para /member-enrollment
      // EXCETO rotas permitidas: enrollment, payments, cards, provider search, resources
      const memberAllowedPaths = [
        '/member-enrollment', '/member-contact', '/member-payments', '/member-cards',
        '/easy-drug-card', '/resources', '/my-documents', '/finlay-lab', '/',
        '/providers', '/providers-map', '/provider-details'
      ];
      const isMemberAllowedPath = memberAllowedPaths.some(p =>
        to.path === p || (p !== '/' && to.path.startsWith(p + '/'))
      );
      if (isFamilyHealthChoice && user.role === 'Member' && !isMemberAllowedPath) {
        console.log('🏥 Router guard: FamilyHealthChoice Member, redirecting to /member-enrollment');
        next('/member-enrollment');
        return;
      }
    }

    // A grid antiga /patients (lista todos os pacientes) fica restrita a
    // Admin/Superuser. Roles do lado do provider usam o /patient-lookup
    // (identidade única), que não expõe a lista.
    const patientsGridBlockedRoles = [
      'Provider', 'Manager', 'Clinical', 'Group', 'Specialist', 'Affiliation',
    ];
    if (
      (to.path === '/patients' || to.path.startsWith('/patients/'))
      && patientsGridBlockedRoles.includes(user.role)
    ) {
      next('/patient-lookup');
      return;
    }
  }
  next();
});

export default router;
